module.exports = __webpack_public_path__ + "images/153_2048.jpg";